<template>
  <div class="certification">
    <mt-header title="资质认证" style="position:fixed;top:0;width:100%;z-index:1000;">
      <div @click="$router.push('/me')" slot="left">
        <mt-button icon="back"></mt-button>
      </div>
    </mt-header>
    <div style="padding:10px;">
      <div  class="authen-slogan">
        完成资质认证 <span> 立即开始接单</span>
      </div>
      <div v-show="notyet" class="authen-start">
        您暂未完成资质认证，请完成以下任务，进行认证吧。
      </div>
      <router-link tag="DIV" :to="{ path: '/baseinfo'}" class="authen authen-not">
        <div :class="{'authen-mark':true,'hang':hangE,'success':successE,'failed':failedE,'conduct':conductE}">{{examine}}</div>
        <div class="authen-word">
          <div class="authen-word-left">
            <div class="authen-word-title">基本信息</div>
            <div class="authen-word-details">完善基本信息，让雇主更加了解你</div>
          </div>
          <div class="authen-word-right">
            <icon name="chevron-right" class='next'></icon>
          </div>
        </div>
      </router-link>
      <div @click="toRealname" class="authen authen-already">
        <div :class="{'authen-mark':true,'hang':hangA,'success':successA,'failed':failedA}">{{authentication}}</div>
        <div class="authen-word">
          <div class="authen-word-left">
            <div class="authen-word-title">实名认证</div>
            <div class="authen-word-details">完善实名认证，让雇主更加信任你</div>
          </div>
          <div class="authen-word-right">
            <icon name="chevron-right" class='next'></icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'certification',
  data(){
    return {
      //基本信息
      examine:'',
      hangE:false,
      hansuccessEgE:false,
      failedE:false,
      conductE:false,
      //实名认证
      authentication:'',
      hangA:false,
      hansuccessEgA:false,
      failedA:false,
      successE:false,
      successA:false,
      url:'',
      notyet:false
    }
  },
  created(){
    this.$emit('footer', false);
  },
  mounted(){
    this.getAccInformation()
  },
  methods:{
    //获取用户基本信息
    getAccInformation(){
      // console.log(sessionStorage.getItem('loginId'),this.STATE.state.loginId)
      let _this = this
      _this.axios({
        method: 'GET',
        url: '/url/account/userInfo/getUserInformationById',
        params: {id:sessionStorage.getItem('loginId')},
      }).then(function (res) {
        if(res.data.account.status == '4' && res.data.accountCertificate.status == '1'){
          _this.notyet = false
        }else{
          _this.notyet = true
        }

        //平台审核
        if (res.data.account) {
          if(res.data.account.status == '0'){//0:未认证
            _this.examine = '未认证'
            _this.hangE  = true
            _this.successE = false
            _this.failedE = false
            _this.conductE = false
          }else if(res.data.account.status == '2'){//2:审核中
            _this.examine = '审核中'
            _this.hangE  = false
            _this.successE = false
            _this.failedE = false
            _this.conductE = true
          }else if(res.data.account.status == '3'){//3:认证失败
            _this.examine = '未通过审核'
            _this.hangE  = false
            _this.successE = false
            _this.failedE = true
            _this.conductE = false
          }else if(res.data.account.status == '4'){//4:审核通过
            _this.examine = '已完成'
            _this.hangE  = false
            _this.successE = true
            _this.failedE = false
            _this.conductE = false
          }
        }

        //实名认证
        if (res.data.accountCertificate) {
          if(res.data.accountCertificate.status == '0'){//0:未认证
            _this.authentication = '未认证'
            _this.hangA  = true
            _this.successA = false
            _this.failedA = false

            _this.url = '0'
          }else if(res.data.accountCertificate.status == '2'){//2:认证失败
            _this.authentication = '未通过审核'
            _this.hangA  = false
            _this.successA = false
            _this.failedA = true

            _this.url = '2'
          }else if(res.data.accountCertificate.status == '1'){//1:审核通过
            _this.authentication = '已完成'
            _this.hangA  = false
            _this.successA = true
            _this.failedA = false

            _this.url = '1'
          }else if(res.data.accountCertificate.status == '4'){//4:未认证(老用户)
            _this.authentication = '未认证'
            _this.hangA  = true
            _this.successA = false
            _this.failedA = false
            _this.url = '0'

          }else if(res.data.accountCertificate.status == '5'){//5:认证失败(老用户)
            _this.authentication = '未通过审核'
            _this.hangA  = false
            _this.successA = false
            _this.failedA = true
            _this.url = '2'

          }
        }
      })
    },
    //实名认证 跳转页面
    toRealname(){
      if(this.url === '1'){
        this.$router.push({path:'/realNameSuccess'})
      }else{
        this.$router.push({path:'/realName'})
      }

    }
  }
}
</script>
<style scoped>
.authen-slogan{
  font-weight: bold;
  font-size: 20px;
}
.authen-slogan span{
  font-size: 16px;
  color: #888;
}
.authen-start{
  font-weight: bold;
  font-size: 16px;
  color: red;
  margin: 20px 0;
}
.authen{
  margin: 20px 0;
  box-shadow: 0 0 8px #888888;
}
.authen-mark{
  height: 28px;
  line-height: 28px;
  margin-left: 70%;
  width: 30%;
  text-align: center;
  color: #fff;
}
.hang{
  background-color: #26a2ff;
}
.success{
  background-color: #67c23a;
}
.failed{
  background-color: #f56c6c;
}
.conduct{/* 灰色 */
  background-color: rgb(179, 179, 179);
}
.authen-word{
  display: flex;
}
.authen-word-left{
  padding: 0 3%;
  width: 74%;
}
.authen-word-title{
  font-weight: bold;
  font-size: 18px;
}
.authen-word-details{
  padding: 20px 0;
  color: #666;
}


.authen-word-right{
  width: 20%;
  margin-top: 30px;
  text-align: center;
  color: #888;
}
</style>




// WEBPACK FOOTER //
// certification.vue?72ea4cc9